export const ForwardFlowIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg width="16" height="16" viewBox="0 0 136 136" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M97.2132 46.2573C96.2976 60.2931 88.6157 70.2881 76.1543 77.4778C70.6058 80.6732 65.6615 85.2527 61.1384 89.8973C56.1026 95.0801 54.4271 101.973 54.2256 109.209C54.1249 112.925 54.0425 116.64 53.8319 120.31C53.2917 130.109 49.4828 134.243 39.2463 135.934C39.2921 122.084 37.4151 108.224 40.9402 94.5791C42.7298 87.1866 46.9231 80.6219 52.8431 75.9451C57.1647 72.5546 61.6237 69.322 66.2017 66.3124C76.6121 59.4385 87.1599 52.7411 97.2132 46.2573Z" fill="white"/>
        <path d="M99.7774 0.065918C100.62 9.90131 97.9256 17.5521 93.1109 24.5599C87.4721 32.7497 79.8242 38.6794 71.7133 44.0415C67.843 46.6044 63.8802 49.016 59.9358 51.4559C51.5101 56.6668 42.9826 61.7264 37.2049 70.7201C33.9273 55.9386 37.6679 45.7344 49.4731 37.9133C55.3156 34.0454 61.5099 30.7732 67.6856 27.397C79.8612 20.6919 90.7869 12.4264 99.7774 0.065918Z" fill="white"/>
        </svg>
    `,
      }}
    />
  );
};
